import Select from "react-select";
import { getFacetSelectStyles, type FacetSelectOption, toFacetSelectOptions } from "./facet-select-styles";

interface FacetFormMultiSelectProps {
    values: string[];
    options: string[];
    onChange: (values: string[]) => void;
    placeholder?: string;
    optionsRefreshKey?: number;
}

export default function FacetFormMultiSelect({
    values,
    options,
    onChange,
    placeholder,
    optionsRefreshKey = 0,
}: FacetFormMultiSelectProps) {
    const mergedOptions = toFacetSelectOptions([...options, ...values]);
    const selected = toFacetSelectOptions(values);

    return (
        <Select<FacetSelectOption, true>
            key={`facet-multi-${optionsRefreshKey}-${options.join("|")}`}
            isMulti
            isClearable={true}
            options={mergedOptions}
            value={selected}
            placeholder={placeholder ?? "Search and select"}
            classNamePrefix="facet-multi-select"
            styles={getFacetSelectStyles(true)}
            onChange={(selectedOptions) => {
                const next = Array.isArray(selectedOptions) ? selectedOptions.map((opt) => opt.value) : [];
                onChange(next);
            }}
        />
    );
}
